import { Dictionary } from './global';

export interface UserEvent {
  id: string;
  country: string;
  language: string;
  mobile: string;
  username?: string;
  first_name?: string;
  email?: string;
  email_confirmation: string;
  created_at: string;
  id_external: string;
  status: string;
  merchant_id?: number;
  merchant_name?: string;
}

export interface BasicUserEvent {
  email?: string;
  id_external?: string;
  merchant_id?: number;
  merchant_name?: string;
}

export enum ErrorsPurchases {
  FRAUDRISK = 'fraud_risk',
  REJECTED = 'transaction_rejected',
  FAILED = 'transaction_failed',
  AMOUNT_EXCEEDED = 'amount_exceeded',
}

export enum ErrorsFraud {
  PURCHASE_BLOCK = 'restriction_applied',
  CROSSED_INTERNAL = 'merchant_gateway_crossed_accounts_internal',
  CROSSED_EXTERNAL = 'merchant_gateway_crossed_accounts_external',
}

export enum ErrorTypes {
  EMAIL = 'email_not_confirmed',
  IDENTITY = 'user_kyc_pending',
  SOF = 'user_sof_required',
  POA = 'user_poa_required',
}
export interface Error {
  status: number;
  description: string;
  message?: string;
  code?: number;
  link?: string;
  error: string;
  required_fields?: string[];
  error_info?: {
    title?: string;
    message: string;
    key: ErrorsPurchases | string;
  };
}

export type EventProps = Dictionary<string | number | boolean | undefined>;

export const EventNames = {
  clickedDifferentMethod: 'click_different_method' as const,
  selectedPaymentMethod: 'selected_payment_method' as const,
  setDefaultPaymentMethod: 'set_default_payment_method' as const,
  kycValidated: 'kyc_validated' as const,
  kycRejected: 'kyc_rejected' as const,
  kycBlocked: 'kyc_blocked' as const,
  userSignUp: 'sign_up_ot' as const,
  firstTimePurchase: 'first_time_purchase_ot' as const,
  purchase: 'purchase_ot' as const,
};

export const CommonFunnelEventNames = {
  phoneEntered: 'fn_phone_entered' as const,
  codeValidated: 'fn_code_validated' as const,
  jumioValidationEntered: 'fn_jumio_validation_entered' as const,
  onfidoValidationEntered: 'fn_onfido_validation_entered' as const,
  pmNoRequiredFieldNorKycSelected: 'fn_pm_no_required_field_nor_kyc_selected' as const,
  pmNoRequiredFieldWithKycSelected: 'fn_pm_no_required_field_with_kyc_selected' as const,
  pmRequiredFieldWithKycSelected: 'fn_pm_required_field_with_kyc_selected',
  pmRequiredFieldNoKycSelected: 'fn_pm_required_field_no_kyc_selected' as const,
};

export const DepositFunnelEventNames = {
  depositInit: 'fn_deposit_init' as const,
  flowCompleted: 'fn_flow_completed' as const,
  walletSelectedAutomatically: 'fn_wallet_selected_automatically' as const,
  walletSelected: 'fn_wallet_selected' as const,
  paymentStarted: 'fn_payment_started' as const,
  apcFromLoginSelected: 'fn_manual_from_login_selected' as const,
  apcFromPmListSelected: 'fn_apc_from_pm_list_selected' as const,
  apcSelectedAutomatically: 'fn_apc_selected_automatically' as const,
  multideviceClickedMobile: 'fn_multidevice_clicked_mobile' as const,
  multideviceClickedDesktop: 'fn_multidevice_clicked_desktop' as const,
};

export const CashoutFunnelEventNames = {
  cashoutInit: 'fn_cashout_init' as const,
  cashoutCompleted: 'fn_cashout_completed' as const,
};

export type TrackerConfig = {
  enabled: boolean;
  event: boolean;
  user: boolean;
  error?: boolean;
};
export abstract class TrackerEvent {
  private _inicialized = false;

  public get inicialized(): boolean {
    return this._inicialized;
  }

  public set inicialized(value: boolean) {
    this._inicialized = value;
  }

  protected valid: (key: keyof TrackerConfig) => boolean = () => {
    return true;
  };

  /** Clear event props
   * @param EventProps props Properties to clear
   */
  protected clear(props: EventProps) {
    return Object.entries(props).reduce((prev, [key, value]) => {
      return !value ? prev : { ...prev, [key]: value };
    }, {});
  }

  /**
   * Initialize service tracker
   * @param init boolean
   */
  protected init() {
    this.inicialized = true;
  }
  /**
   * Track event
   * @param eventName string
   * @param props { [key: string]: string | number | booolean  }
   */
  public trackEvent: (eventName: string, props: EventProps) => void = () => {
    //
  };
  /**
   * Track error
   * @param error Error
   * @param errorInfo React.ErrorInfo
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public trackError?: (error: Error, errorInfo?: any) => void = () => {
    //
  };
  /**
   * Track user
   * @param user UserEvent
   * @param newUser boolean
   */
  public trackUser: (user: UserEvent, newUser?: boolean) => void = () => {
    //
  };
  /**
   * Track page is visited
   * @param page Name of visited page
   */
  public trackPageView?: (page: string) => void = () => {
    //
  };
}

export abstract class AdapterService {
  static adapt: <T extends unknown, R extends unknown>(r: T) => R;
}
